import { render, staticRenderFns } from "./quotaHead.vue?vue&type=template&id=1b372d7c&scoped=true&"
import script from "./quotaHead.vue?vue&type=script&lang=js&"
export * from "./quotaHead.vue?vue&type=script&lang=js&"
import style0 from "./quotaHead.vue?vue&type=style&index=0&id=1b372d7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b372d7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b372d7c')) {
      api.createRecord('1b372d7c', component.options)
    } else {
      api.reload('1b372d7c', component.options)
    }
    module.hot.accept("./quotaHead.vue?vue&type=template&id=1b372d7c&scoped=true&", function () {
      api.rerender('1b372d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/quota/quotaHead.vue"
export default component.exports